export function getInitialAvatarFrom(value: string): string {
  if (!value) return '';
  const fullName = value.split(' ');
  const initials = `${fullName?.[0]?.charAt(0) ?? ''} ${
    fullName?.length > 1
      ? fullName?.[fullName?.length - 1]?.charAt(0)
      : (fullName?.[0]?.charAt(1) ?? '')
  }`;
  return initials.trim().toUpperCase();
}
export function isJsonString(arg) {
  try {
    JSON.parse(arg);
  } catch (e) {
    return false;
  }
  return true;
}
export function getMaskedValue(value: string, mask: string): string {
  if (!value || !mask) {
    return value || '';
  }

  let maskedValue = '';
  let valueIndex = 0;

  for (let i = 0; i < mask.length; i++) {
    const maskChar = mask[i];

    if (maskChar === '9') {
      // Digit placeholder
      if (/\d/.test(value[valueIndex])) {
        maskedValue += value[valueIndex];
        valueIndex++;
      } else {
        break; // Invalid character for digit position
      }
    } else if (maskChar === 'a') {
      // Letter placeholder
      if (/[a-zA-Z]/.test(value[valueIndex])) {
        maskedValue += value[valueIndex];
        valueIndex++;
      } else {
        break; // Invalid character for letter position
      }
    } else if (maskChar === '*') {
      // Any character placeholder
      maskedValue += value[valueIndex];
      valueIndex++;
    } else {
      // Literal character in mask
      maskedValue += maskChar;
    }
  }

  return maskedValue;
}
